export default "__VITE_ASSET__0JkPCYUj__";